import { render, staticRenderFns } from "./SalesTracking.vue?vue&type=template&id=f89f3700"
import script from "./SalesTracking.vue?vue&type=script&lang=js"
export * from "./SalesTracking.vue?vue&type=script&lang=js"
import style0 from "./SalesTracking.vue?vue&type=style&index=0&id=f89f3700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports